import { render, staticRenderFns } from "./distributionProcessed.vue?vue&type=template&id=612bd588&scoped=true&"
import script from "./distributionProcessed.vue?vue&type=script&lang=js&"
export * from "./distributionProcessed.vue?vue&type=script&lang=js&"
import style0 from "./distributionProcessed.vue?vue&type=style&index=0&id=612bd588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612bd588",
  null
  
)

export default component.exports